import React, { useState } from 'react';

import Grid from '@mui/material/Grid2';

import ImageInput from "@dndComponents/other/ImageInput";
import ModalOrDrawer from "@components/display/ModalOrDrawer";
import ButtonBox from "@components/input/buttons/ButtonBox";

interface Props {
  name: string;
  image_url: string;
  select_options?: string[];
  disabled: boolean;
  onChange: (changed: string) => void;
}

export default function ImageButton({
  name,
  image_url,
  select_options,
  disabled,
  onChange,
}: Props) {
  const [open, setOpen] = useState(false);

  const renderExtras = () => {
    return (
      <ModalOrDrawer
        open={ open } 
        onClose={() => {
          setOpen(false);
        }}>
        { open &&
          <ImageInput
            name={name}
            image_url={image_url}
            select_options={select_options}
            onChange={onChange}
          />
        }
      </ModalOrDrawer>
    );
  }

  return (
    <>
      <div className="centered" style={{ 
          float: "left",
          // width: "5em",
          // height: "5em" 
        }}>
        <Grid container spacing={0} direction="row">
          { image_url !== "" &&
            <Grid
              size={{
                xs: 12
              }}>
              <img src={ image_url } alt={name} className='clickable'
                style={{
                  maxWidth: "200px",
                  maxHeight: "200px",
                  border: "1px solid",
                }}
                onClick={() => {
                  if (!disabled) {
                    setOpen(true);
                  }
                }}
              />
            </Grid>
          }
          <Grid
            size={{
              xs: 12
            }}>
            <ButtonBox
              name={name}
              disabled={disabled}
              onClick={() => {
                if (!disabled) {
                  setOpen(true);
                }
              }}
            />
          </Grid>
        </Grid>
      </div>
      { renderExtras() }
    </>
  ); 
}

